var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.5,
    viewBox: "0 0 32 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Light",
    transform: "translate(-253 -70.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "container-icon",
    width: 32,
    height: 32,
    transform: "translate(253 71)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-Light-2",
    "data-name": "icon-Light",
    d: "M31.306,45.86a4.52,4.52,0,0,0,4.5-4.539v-.886H45.921v-.443a14.73,14.73,0,0,0-4.1-10.182,14.456,14.456,0,0,0-9.959-4.438V13.86h-.877V25.372a14.45,14.45,0,0,0-9.962,4.443,14.728,14.728,0,0,0-4.1,10.191v.443H26.81v.886a4.523,4.523,0,0,0,4.5,4.525Zm3.622-4.539a3.619,3.619,0,1,1-7.238,0v-.886h7.238ZM31.421,26.266a13.571,13.571,0,0,1,9.464,3.874,13.835,13.835,0,0,1,4.151,9.423H17.807a13.84,13.84,0,0,1,4.144-9.438,13.573,13.573,0,0,1,9.471-3.881Z",
    transform: "translate(237.579 57.14)",
    stroke: "#151515",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.b401cffc865866066d14723498247a7a.svg";
export { ForwardRef as ReactComponent };